import { http } from '@kunlun/dependencies';

export const queryCodeImg = async () => {
  const gql = `
  query {
    ariesMallQrCodeQuery {
      queryQrCode(data: {}) {
        qrCodeUrl
      }
    }
  }
  `;
  const res = await http.query<{ qrCodeUrl: string }>('ariesCoreMerchant', gql);
  return res.data.ariesMallQrCodeQuery.queryQrCode?.qrCodeUrl ?? '';
};
